import React, { useState } from "react";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { Button } from "./ui/button";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "./ui/dialog";
import { Lifebuoy } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function SupportContact() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ subject: "", message: "" });
  const [busy, setBusy] = useState(false);
  const { isImpersonating } = useAuth();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/support/tickets", form);
      toast.success("Support ticket submitted — we'll reply by email.");
      setOpen(false);
      setForm({ subject: "", message: "" });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to submit");
    } finally { setBusy(false); }
  };

  return (
    <>
      <Button
        variant="outline"
        className="rounded-xl border-[#184A30] text-[#184A30]"
        onClick={() => setOpen(true)}
        disabled={isImpersonating}
        title={isImpersonating ? "View-as mode is read-only" : undefined}
        data-testid="support-contact-btn"
      >
        <Lifebuoy size={16} className="mr-1" /> Contact support
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="bg-[#FBF9F6] border-[#E5E0D8]" data-testid="support-contact-dialog">
          <DialogHeader>
            <DialogTitle className="serif text-3xl">Contact support</DialogTitle>
            <DialogDescription className="text-[#4A5C50]">We reply within 24 hours by email.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="space-y-5 py-2">
            <div>
              <Label className="text-xs tracking-widest uppercase text-[#4A5C50]">Subject</Label>
              <input className="underline-input" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} minLength={3} required data-testid="ticket-subject" />
            </div>
            <div>
              <Label className="text-xs tracking-widest uppercase text-[#4A5C50]">Message</Label>
              <Textarea rows={6} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} minLength={3} required className="mt-2 rounded-xl border-[#E5E0D8]" data-testid="ticket-message" />
            </div>
            <DialogFooter>
              <Button type="button" variant="ghost" onClick={() => setOpen(false)} data-testid="ticket-cancel">Cancel</Button>
              <Button type="submit" disabled={busy} className="rounded-xl bg-[#184A30] hover:bg-[#0F3320] text-white" data-testid="ticket-submit">
                {busy ? "Sending…" : "Submit ticket"}
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
